import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const NumberManagementInternalPortedNumbersReportSlice = createSlice({
  name: "NumberManagementInternalPortedNumbersReportSlice",
  initialState: {},
  reducers: {},
});

export const addNumberManagementInternalPortedNumbersReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const { year, month } = payload || {};

      // Ensure `request_id` is included in the payload
      const requestBody: any = {
        year,
        month,
      };

      // Make the API request with the constructed body
      const res = await api.post(
        API_URL.INTERNAL_PORTED_NUMBERS.ADD,
        requestBody
      );
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListNumberManagementInternalPortedNumbersReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        year,
        month,
        date = "",
        current = 1,
        page_size = 10,
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `report_date=${date}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      if (year) {
        actionParts.push(...actionParts, `year=${year}`);
      }

      if (month) {
        actionParts.push(...actionParts, `month=${month}`);
      }

      const uniqueArr = [...new Set(actionParts)];

      // Join query parts
      const action = `?${uniqueArr.join("&")}`;

      // Make the API call
      const response = await api.get(
        API_URL.INTERNAL_PORTED_NUMBERS.LIST + action
      );

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteNumberManagementInternalPortedNumbersReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.INTERNAL_PORTED_NUMBERS.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default NumberManagementInternalPortedNumbersReportSlice.reducer;
